import React from "react";
import TimeGeneralInput from "../../input/time-general-input";

const Time1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-center h-full w-full">
      {widget && (
        <TimeGeneralInput
          valueSpec={widget}
          onChange={handleValueUpdate}
          embedded={false}
          zIndex="var(--z-index-automation-input)"
        />
      )}
    </div>
  );
};

export default Time1Widget;
